import { render } from "./HistoryPanel.vue?vue&type=template&id=4122a94b&scoped=true"
import script from "./HistoryPanel.vue?vue&type=script&lang=ts"
export * from "./HistoryPanel.vue?vue&type=script&lang=ts"

import "./HistoryPanel.vue?vue&type=style&index=0&id=4122a94b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4122a94b"

export default script